import React from "react";
import "./Hero.css";
import { Link } from "react-router-dom";
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WaheedFace from "../../assets/img2.png"
import background from "../../assets/background.svg"
import middlebackgr from  "../../assets/middlebackgr.svg"
import leftbackgr from "../../assets/leftbackgr.svg"
import bg from "../../assets/icons/bg.svg"
import footer from "../../assets/footer.svg"
import TiktokIcon from "../../assets/icons/tiktokIcon.svg"
import waheedLogo from "../../assets/icons/waheedLogo.svg"
import { useTranslation } from "react-i18next";
export default function Hero() {
  const {t, i18n} = useTranslation();
  

  return (
    <div>
      <img
        className="waheedlogo"
        src={waheedLogo}
        style={{ alignItems: "end" }}
      />

      <div className="hero-section">
        <div className="hero-content">
          <h1>{t("Invest_in_Change")}</h1>
          <h3>"{t("quote")}"</h3>
          {/* wrapped the info of the name and description in a div for customize the spacing */}
          <div class="info">
            <h4 className="hero-name">{t("name")}</h4>
            <h4 className="hero-description">{t("description")}</h4>
          </div>

        {/* <a href="https://www.facebook.com/yourprofile" target="_blank" rel="noopener noreferrer">
    
  <button className="icon-button">
<TiktokIcon/>

  </button>
</a> */}


          {/* wrapped the a tags in communicatin_links div for using the flex layout in it */}
          <div class="communication_links">
            <a
              href="https://www.instagram.com/aljassas2010/profilecard/?igsh=MWM2M3loc2RxNmk4Nw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="icon-button">
                <InstagramIcon />
              </button>
            </a>

            <a
              href="https://x.com/Waheed_Aljassas"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="icon-button">
                <XIcon />
              </button>
            </a>

            <a
              href="https://www.linkedin.com/in/waheed-al-jassas-mba-fr-ilm-fm-0243b332?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="icon-button">
                <LinkedInIcon />
              </button>
            </a>
          </div>

        </div>

        {/* added images in a class to reposition the whole image */}
        <div class="images">
          <img src={leftbackgr} alt="left-backgr" className="left-backgr" />
          <img src={background} alt="right-backgr" className="right-backgr" />
          <img src={bg} className="background" alt="waheedLogo" />
          <img src={middlebackgr} alt="mid-backgr" className="mid-backgr" />

          <img src={WaheedFace} alt="Waheed Face" className="waheed-icon" />
          <img src={footer} alt="footer" className="footer" />
        </div>
      </div>
    </div>
  );
}
